export default "__VITE_ASSET__Bq12c5Yy__"